import { InjectionToken } from '@angular/core'

/**
 * Базовый префикс для ассетов, которые лежат внутри библиотеки core
 * (`projects/core/src/assets` → `assets/**` в собранном приложении).
 *
 * Зачем: приложение beatmaker-tv встраивается в страницы монолита как набор custom elements,
 * поэтому относительный путь `assets/images/...` резолвится от `<base href="/">` страницы-хоста,
 * а не от места, откуда загружен бандл. После переезда статики на отдельный поддомен
 * (`https://spa.beatmaker.tv`) пути к ассетам должны стать абсолютными.
 *
 * Значение по умолчанию — пустая строка: в этом случае {@link AssetUrlPipe} возвращает путь
 * без изменений, то есть поведение остаётся ровно таким, каким было до появления токена.
 * Приложение переопределяет значение через `{ provide: ASSETS_BASE_URL, useValue: '...' }`.
 */
export const ASSETS_BASE_URL = new InjectionToken<string>('AssetsBaseUrl', {
  providedIn: 'root',
  factory: () => ''
})
